module.exports = __webpack_public_path__ + "img/lobster.70b0da86.png";